import React from "react";
import {
  Card,
  CardContent,
  Avatar,
  Typography,
  Container,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "453px",
    maxHeight: "410px",
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto",
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "410px",
    padding: "3em",
    [theme.breakpoints.down("md")]: {
      padding: "1.3em",
    },
  },
  avatar: {
    display: "flex",
    justifyContent: "start",
    paddingLeft: 0,
    marginBottom: "2em !importatnt",
  },
  alignLeft: {
    textAlign: "left",
  },
}));

export default function LearnerStory({
  time,
  msg,
  avatar,
  name,
  job,
  colorStory,
}) {
  const classes = useStyles();
  return (
    <Card
      className={classes.root}
      variant="outlined"
      style={{ backgroundColor: colorStory }}
    >
      <CardContent className={classes.content}>
        <section>
          <Typography
            variant="subtitle2"
            color="secondary"
            className={classes.alignLeft}
          >
            {time}
          </Typography>
          <Typography variant="subtitle1" color="primary">
            {msg}
          </Typography>
        </section>
        <section>
          <Container className={classes.avatar}>
            <Avatar alt={name} src={avatar} />
            <Container>
              <Typography variant="subtitle1" color="primary">
                {name}
              </Typography>
              <Typography variant="subtitle2" color="secondary">
                {job}
              </Typography>
            </Container>
          </Container>
        </section>
      </CardContent>
    </Card>
  );
}
